import React, { useEffect, useState } from "react";
import { Chip, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { getDataFromCmsApi } from "../../api/contentful-service";
import { parseHtml } from "../../utils/utils";
import StaticPageContainer from "../../components/static-page/static-page";
import { useMuiScreenSizes } from "../../hooks/useMuiScreenSizes";

const apiName = "ImportantDate";

function ImportantDates() {
  const { isScreenMedium, isScreenXLarge, isScreenXXLarge } = useMuiScreenSizes();
  const [importantDates, setImportantDates] = useState();
  const [pageContent, setPageContent] = useState();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const datesResult = await getDataFromCmsApi(apiName);
    datesResult.map((item) => {
      item.serviceDescription = parseHtml(item.serviceDescription);
      return item;
    });
    setImportantDates(datesResult);

    const contentResult = await getDataFromCmsApi("webpage/importantDates");
    setPageContent(contentResult);
  };

  return (
    importantDates &&
    pageContent && (
      <StaticPageContainer title={`${pageContent.pageTitle}`}>
        <TableContainer
          sx={{
            paddingX: !isScreenXXLarge ? "90px" : !isScreenXLarge ? "45px" : !isScreenMedium ? "30px" : "0px"
          }}
        >
          <Table>
            <TableBody>
              {importantDates &&
                importantDates.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell
                      className="pb-0"
                      component="th"
                      scope="row"
                      align="right"
                      style={{ fontWeight: "bold" }}
                    >
                      <Chip
                        className="mb-3 w-100"
                        color="primary"
                        variant="outlined"
                        label={`${row.month} ${row.day !== 0 ? row.day : ""}`}
                      />
                    </TableCell>

                    <TableCell className="pb-0" style={{ fontSize: "medium" }}>
                      {row.serviceDescription}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div className="mt-4 p-5 text-center">{parseHtml(pageContent.content)}</div>
      </StaticPageContainer>
    )
  );
}
export default ImportantDates;
